(function () {
  const hamburger = document.querySelector(".hamburger");
  const mobileNav = document.querySelector("nav[data-mobile-nav]");
  const desktopNav = document.querySelector("nav[data-desktop-nav]");
  
  // Hide desktop navigation (we always use hamburger menu)
  if (desktopNav) {
    desktopNav.style.display = "none";
  }
  
  if (hamburger && mobileNav) {
    const nav = mobileNav; // Always use mobile nav for hamburger menu
    const body = document.body;
    const logo = document.querySelector("header .logo");
    const langSwitcher = nav.querySelector(".lang-switcher");
    
    // Ensure language switcher is at the bottom of menu
    function positionLangSwitcher() {
      if (langSwitcher && nav) {
        // Move lang switcher to end of nav (if not already there)
        const currentParent = langSwitcher.parentElement;
        if (currentParent === nav) {
          // Already in nav, just ensure it's at the end
          nav.appendChild(langSwitcher);
        }
      }
    }
    
    // Position language switcher
    positionLangSwitcher();
    
    hamburger.addEventListener("click", () => {
      const isActive = nav.classList.toggle("is-active");
      hamburger.classList.toggle("is-active");
      if (isActive) {
        body.classList.add("menu-open");
        // Ensure language switcher is positioned correctly
        positionLangSwitcher();
      } else {
        body.classList.remove("menu-open");
      }
    });
    
    // Function to close menu
    function closeMenu() {
      nav.classList.remove("is-active");
      hamburger.classList.remove("is-active");
      body.classList.remove("menu-open");
    }
    
    // Close menu when clicking on backdrop
    nav.addEventListener("click", (e) => {
      if (e.target === nav) {
        closeMenu();
      }
    });
    
    // Close menu when clicking on any navigation link (but not the logo)
    nav.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link && !link.classList.contains("menu-logo") && !link.closest(".menu-logo")) {
        // For anchor links, wait a bit for scroll to happen
        if (link.getAttribute("href") && link.getAttribute("href").includes("#")) {
          setTimeout(() => {
            closeMenu();
          }, 300);
        } else {
          // For regular links, close immediately
          setTimeout(() => {
            closeMenu();
          }, 100);
        }
      }
    });
  }
})();
